import { useEffect, useState } from 'react'

export const useRecentlyUploaded = (uploadedOn: number | undefined, timeout = 2000) => {
  const [recentlyUploaded, setRecentlyUploaded] = useState(false)
  useEffect(() => {
    if (uploadedOn) {
      const now = Date.now()
      if (now - uploadedOn < timeout) {
        setRecentlyUploaded(true)
        setTimeout(() => {
          setRecentlyUploaded(false)
        }, timeout)
      }
    }
  }, [uploadedOn, timeout])

  return recentlyUploaded
}
